module.exports = __webpack_public_path__ + "static/font-369f76563002406b8ab2c5d1ccfd108d.woff2";